// DS: C02 // a duplicate because Popper doesn't render on SSR // will be cleaned up once promo is over - T48724
import React from 'react';
import c from 'classnames';
import CoreIconSmall from '@wix/da-shared-react/pkg/Icons/CoreIconSmall';
import s from './CoreSaleTooltip.scss';

export interface Props {
  isActive?: boolean;
  message?: string;
  className?: string;
}

export const CoreSaleTooltip: React.FC<Props> = ({
  className,
  isActive,
  message,
}) => {
  if (!isActive || !message) {
    return null;
  }
  return (
    <div className={c(s['root'], className)}>
      <CoreIconSmall className={s['core-sale-icon']} />
      <div
        className={s['core-sale-copy']}
        dangerouslySetInnerHTML={{ __html: message }}
      />
      <div className={s['arrow']} />
    </div>
  );
};
CoreSaleTooltip.displayName = 'CoreSaleTooltip';

export default CoreSaleTooltip;
